import React from 'react';
import {Route, RouteProps, useHistory} from 'react-router-dom';
import ErrorBoundary from 'app/shared/error/error-boundary';

const DebugRouter = ({ children }: { children: any }) => {
  const { location } = useHistory()
  /* eslint-disable no-console */
  console.log(
    `Route: ${location.pathname}${location.search}, State: ${JSON.stringify(location.state)}`,
  );
  console.log(children);
  /* eslint-enable no-console */
  return children
}

export const ErrorBoundaryRoute = ({ component: Component, ...rest }: RouteProps) => {
  const encloseInErrorBoundary = props => (
    <DebugRouter>
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
    </DebugRouter>
  );

  if (!Component) throw new Error(`A component needs to be specified for path ${(rest as any).path}`);

  return <Route {...rest} render={encloseInErrorBoundary} />;
};

export default ErrorBoundaryRoute;
